import styled from 'styled-components';

const UTP = {
  TotalDiv: styled.div`
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 2000;
      background-color: rgba(15, 23, 42, 0.42);
      backdrop-filter: blur(4px);
      cursor: default;
  `,

  InnerTotalDiv: styled.div`
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #ffffff;
      padding: 28px 8px 24px;
      border-radius: 20px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      width: 74%;
      height: 74%;
      box-shadow: 0 24px 60px rgba(15, 23, 42, 0.22);
  `,

  PopupTitle: styled.h1`
      margin: 12px 0 20px;
      font-size: 24px;
      font-weight: 700;
      letter-spacing: -0.4px;
      color: #111827;
  `,

  TableWrapper: styled.div`
      padding: 0 28px 8px;
      overflow: auto;
      width: 100%;
      box-sizing: border-box;
      flex: 1;

      &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }

      &::-webkit-scrollbar-thumb {
        background: #d5dbe3;
        border-radius: 99px;
      }
  `,

  StyledTable: styled.table`
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;
      margin: 0 auto;
      background: #ffffff;
      border: 1px solid #eceff3;
      border-radius: 14px;
      overflow: hidden;
  `,

  ColGroup: styled.colgroup`
      col:first-child {
          width: 7%;
      }
      col:nth-child(2) {
          width: 18%;
      }
      col:nth-child(3) {
          width: 22%;
      }
      col:nth-child(4) {
          width: 13%;
      }
      col:nth-child(5) {
          width: 22%;
      }
      col:nth-child(6) {
          width: 18%;
      }
  `,

  Thead: styled.thead`
      position: sticky;
      top: 0;
      z-index: 1;
  `,

  Th: styled.th`
      padding: 14px 12px;
      text-align: center;
      font-size: 14px;
      font-weight: 700;
      letter-spacing: -0.2px;
      color: #334155;
      background-color: #e8eef8;
      border: none;
      border-bottom: 1px solid #d5deea;
      white-space: nowrap;
  `,

  Tbody: styled.tbody`
      font-size: 15px;
      color: #1f2937;
  `,

  TbodyRow: styled.tr`
      transition: background 0.15s ease;

      &:hover {
          background-color: #f5f8ff;
      }

      &:last-child td {
          border-bottom: none;
      }
  `,

  Td: styled.td`
      padding: 14px 12px;
      border: none;
      border-bottom: 1px solid #f0f2f5;
      text-align: center;
      font-size: 15px;
      color: #374151;

      &:first-child {
          color: #64748b;
          font-variant-numeric: tabular-nums;
          font-weight: 600;
      }
  `,

  EmptyTd: styled.td`
      padding: 48px 12px;
      text-align: center;
      color: #64748b;
      border: none;
      font-size: 15px;
  `,

  Muted: styled.span`
      color: #64748b;
  `,
}

export default UTP;
